import React from 'react'
import { getFromNowAsText } from '../../helpers/timeHelper'
import { getLastEventLogName } from '../../helpers/lastEventLogHelper'

type Props = {
  lastEventLog?: ILastEventLog | null
}

const LastEventLogSummary = ({ lastEventLog }: Props) => {
  if (!lastEventLog) {
    return <span>-</span>
  }

  return (
    <div className="last-event-log-summary">
      <div className="last-event-log-summary__name">
        {getLastEventLogName(lastEventLog)}
      </div>
      {lastEventLog.source_name && (
        <div className="last-event-log-summary__source-name">
          {lastEventLog.source_name}
        </div>
      )}
      {lastEventLog.at && (
        <div className="last-event-log-summary__at">
          {getFromNowAsText(lastEventLog.at)}
        </div>
      )}
    </div>
  )
}

export default LastEventLogSummary
